import * as Blockly from 'blockly';
import { useStore } from '../state/store';
import { saveProject } from './cloud';
import { getWorkspace } from './workspace';

/**
 * Cloud autosave: after the canvas goes quiet for 3 seconds the project is
 * saved under its current name (the cloud upserts by user + name). Status is
 * surfaced in the store so the header can show it.
 */

const AUTOSAVE_DELAY_MS = 3000;

let timer: number | undefined;

export function markCloudDirty(): void {
  const store = useStore.getState();
  store.setSaveStatus('dirty');
  window.clearTimeout(timer);
  timer = window.setTimeout(() => void saveNow(), AUTOSAVE_DELAY_MS);
}

export async function saveNow(): Promise<void> {
  window.clearTimeout(timer);
  const store = useStore.getState();
  const name = store.projectName.trim();
  if (!name) {
    store.setSaveStatus('idle');
    return;
  }
  const ws = getWorkspace();
  if (!ws || ws.getTopBlocks(false).length === 0) {
    // Nothing to save yet (or we are not in the editor at all).
    store.setSaveStatus('idle');
    return;
  }
  store.setSaveStatus('saving');
  try {
    const data = JSON.stringify(Blockly.serialization.workspaces.save(ws));
    await saveProject(name, data);
    const latest = useStore.getState();
    latest.setLastSavedAt(new Date().toISOString());
    latest.setSaveStatus('saved');
  } catch {
    const latest = useStore.getState();
    latest.setSaveStatus('error');
  }
}
